import { AxiosError, AxiosHeaders } from "axios";
import { axiosInstance } from "../../../api/axiosInstance";
import { EASY_EDU_SERVER_BASE_URL } from "../../../environment";
import { APIS, PAYMENT_APIS } from "../../../modules/common/api/apis";
import { getAxiosHeaders } from "../../../modules/common/shared/AxiosAPI";
import { openReceiptPrint } from "../receipt/receiptPrint";
import { Fee, StudentPOStatusShort, TuitionPaymentRequest } from "../types";

export const payStudentFee = async (feeData: Fee): Promise<{ receiptNo: string }> => {
  const response = await axiosInstance.post(APIS.PAY_STUDENT_FEE, feeData);
  return response.data;
};

export const initiateStudentPayment = async (feeData: TuitionPaymentRequest): Promise<string> => {
  const response = await axiosInstance.post(PAYMENT_APIS.INITIATE_PAYMENT, feeData);
  return response.data;
};

export const getPaymentHistory = async (admissionNo: string): Promise<StudentPOStatusShort[]> => {
  const response = await axiosInstance.get(PAYMENT_APIS.GET_PAYMENT_HISTORY, { params: { admissionNo } });
  return response.data;
};

// The backend works out who may see the receipt from the login; no student/grade headers needed.
export const printClassicReceipt = (receiptNo: number) => {
  printPDF(APIS.FEE_RECEIPT_PDF.replace("receipt_no", receiptNo.toString()), getAxiosHeaders());
};

// Asks Classic (server PDF) or New (browser PDF) - see receipt/ReceiptPrintHost
export const printReceipt = (receiptNo: number) => {
  openReceiptPrint(receiptNo, printClassicReceipt);
};

export const printPDF = (url: string, headers: AxiosHeaders) => {
  if (headers === null) {
    headers = getAxiosHeaders();
  }
  axiosInstance
    .get(EASY_EDU_SERVER_BASE_URL + url, {
      headers: headers,
      responseType: "blob",
    })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.pdf");
      document.body.appendChild(link);
      link.click();
    })
    .catch((error: AxiosError) => {
      console.log("Going to call pdf endpoint: " + error);
      console.log(error);
      if (error.response?.status === 401) {
        console.log("Error code: " + error.response?.status);
      }
      alert(error.response?.data);
    });
};
